import { SET_DATA_KEY } from '../../../model/constants'
import updateSetWorkoutExerciseAction from '../update-set'
import { getCurrentSetWorkoutExerciseSelect } from '../../selectors/get-current-set'
import { updateWeightUnitSetDataUtil } from '../../../model'

function updateSetWeightUnitWorkoutExerciseAction (value) {
  return (dispatch, getState) => {
    const set = getCurrentSetWorkoutExerciseSelect(getState())
    dispatch(updateSetWorkoutExerciseAction({
      set: updateWeightUnitSetDataUtil(set, value),
      key: SET_DATA_KEY.WEIGHT_UNIT,
      shouldNotSave: true
    }))
  }
}

export { updateSetWeightUnitWorkoutExerciseAction }
